import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Loader } from 'components/Loader';

import { MessagesSetForm } from './components/MessagesSetForm';

import { useGetMessagesSetQuery } from 'data/__generated__';

type ParamTypes = {
    messagesSetId: string;
};

export const MessagesSetDetails = () => {
    const { messagesSetId = '' } = useParams<ParamTypes>();

    const {
        loading: messagesSetLoading,
        data: messagesSetData,
        error: messagesSetError,
    } = useGetMessagesSetQuery({ variables: { messagesSetId } });

    if (messagesSetLoading) {
        return (
            <Container>
                <Loader />
            </Container>
        );
    }

    if (!messagesSetData || messagesSetError) {
        throw new Error('Une erreur est survenue lors de la récupération de la série');
    }

    const { messagesSet } = messagesSetData;

    if (!messagesSet) {
        throw new Error('Une erreur est survenue lors de la récupération de la série');
    }

    return (
        <Container>
            <MessagesSetForm messagesSet={messagesSet} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex: 1;
    background-color: ${({ theme }) => theme.backgroundColor};
`;
